import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"

registerNotification("friend_request_notification", {
	handle: ({ notification_id, data }) => {
		showNotification({
			type: "friend-request",
			placement: "home",
			origin: "server",
			name: "friend_request_notification",
			notificationId: notification_id,
			data: {
				friend: data.friend,
				demean: data.demean ?? "",
				invitationId: data.invitation_id,
			},
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
